import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-col gap-4 text-left",
  "data-testid": "upload-modal-new-sheet-step"
}
const _hoisted_2 = {
  class: "text-sm text-neutral50",
  "data-testid": "upload-modal-new-sheet-text"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "nova folha", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Aguardando Auditoria", -1)

import { computed } from 'vue'
import { NEW_SHEET_MIN_JUSTIFICATION } from './rejected-sheet'


export default /*#__PURE__*/_defineComponent({
  __name: 'StepNewSheet',
  props: {
    modelValue: {},
    formattedDate: {},
    targets: { default: () => [] },
    hasOtherSchedules: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;



const targetsLabel = computed(() => {
  if (!props.targets.length) return 'deste registro'
  const quoted = props.targets.map((name) => `“${name}”`)
  return props.targets.length === 1
    ? `da escala ${quoted[0]}`
    : `das escalas ${quoted.slice(0, -1).join(', ')} e ${quoted[quoted.length - 1]}`
})
const returnsLabel = computed(() =>
  props.targets.length > 1 ? 'os registros voltam' : 'o registro volta'
)


const hint = computed(() =>
  props.modelValue.trim().length < NEW_SHEET_MIN_JUSTIFICATION
    ? `Obrigatória — mínimo de ${NEW_SHEET_MIN_JUSTIFICATION} caracteres`
    : ''
)

return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(" A folha de "),
      _createElementVNode("b", null, _toDisplayString(_ctx.formattedDate), 1),
      _createTextVNode(" " + _toDisplayString(targetsLabel.value) + " foi reprovada. Envie a folha selecionada como ", 1),
      _hoisted_3,
      _createTextVNode(": a folha recusada continua disponível em “Folhas anteriores” e " + _toDisplayString(returnsLabel.value) + " para ", 1),
      _hoisted_4,
      _createTextVNode(". "),
      (_ctx.hasOtherSchedules)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" As demais escalas selecionadas recebem a mesma folha normalmente. ")
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_textarea, {
      "model-value": _ctx.modelValue,
      label: "Justificativa",
      placeholder: "Ex.: folha corrigida após a reprovação",
      variant: "outlined",
      density: "compact",
      rows: "3",
      counter: "1000",
      maxlength: "1000",
      hint: hint.value,
      "persistent-hint": "",
      "data-testid": "upload-modal-new-sheet-justification",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event ?? '')))
    }, null, 8, ["model-value", "hint"])
  ]))
}
}

})